// Round 1 (C1): run fn once the browser is idle after the first paint (requestIdleCallback, capped at 2 s), so non-visible shell badges
// do not compete with the page's own reads at boot. setTimeout where requestIdleCallback is missing (Safari, jsdom). Returns cancel().
// Round 4c: and once the page's own reads have settled (nothing in flight, nothing started for QUIET_MS), at most CAP_MS after the idle
// point: the badges used to go out WITH the page's reads (8 extra calls in flight on Bands / Farms). Display-only reads, so a later start is safe.
import { netQuietFor } from '../services/netActivity.mjs';
const QUIET_MS = 120, CAP_MS = 2500;
export function afterPaint(fn, win = typeof window !== 'undefined' ? window : null) {
  let timer = null, off = false, t0 = 0;
  const run = () => { if (off) return; if (netQuietFor(QUIET_MS) || Date.now() - t0 > CAP_MS) fn(); else timer = setTimeout(run, 60); };
  const go = () => { t0 = Date.now(); run(); };
  if (win && typeof win.requestIdleCallback === 'function') {
    const h = win.requestIdleCallback(go, { timeout: 2000 });
    return () => { off = true; clearTimeout(timer); win.cancelIdleCallback(h); };
  }
  timer = setTimeout(go, 200);
  return () => { off = true; clearTimeout(timer); };
}
